import React, { createContext, useReducer } from 'react';
import theme from '../styles/Themes';

const vars = {
  ROOT_URL: window.location.origin,
  COURSE_API: '/wp-json/ttcourse/v1/tti-course/',
  COURSE_SETTINGS_API: '/wp-json/ttcourse/v1/tti-course/settings/',
  COURSE_PROGRESS_API: '/wp-json/ttcourse/v1/course/progress',
  COURSE_ENROLL_API: '/wp-json/ttcourse/v1/course/enroll',
  STRIPE_INTENT_API: '/wp-json/ttcourse/v1/stripe/intent',
  STRIPE_CONFIRM_API: '/wp-json/ttcourse/v1/stripe/confirm',
  STRIPE_KEY_API: '/wp-json/ttmembership/v1/stripe/key',
};

const initialState = {
  currentTheme: theme.light,
  course: null,
  isCourseLoading: false,
  courseError: null,
  isCoursePurchased: false,
  isCourseFree: false,
  isLessonsLocked: false,
  isUserLoggedIn: false,
  latestLesson: null,
  stripeKey: null,
  refreshTime: null,
  isStripeModalOpen: false,

  envVars: vars,
  cachingVersion: 0,
};

const AppContext = createContext(initialState);

const reducer = (state, action) => {
  switch (action.type) {
    case 'toggleTheme':
      return {
        ...state,
        currentTheme:
          state.currentTheme.name === 'light' ? theme.dark : theme.light,
      };
    case 'setCourseLoading':
      return { ...state, isCourseLoading: true };
    case 'setCourseError':
      return {
        ...state,
        courseError: action.error,
        isCourseLoading: false,
      };
    case 'setCourse':
      return {
        ...state,
        course: action.course,
        isCourseLoading: false,
      };
    case 'setCoursePurchased':
      return { ...state, isCoursePurchased: action.isCoursePurchased };
    case 'setCourseFree':
      return { ...state, isCourseFree: action.isCourseFree };
    case 'setLessonsLocked':
      return { ...state, isLessonsLocked: action.lessonsLocked };
    case 'setUserLoggedIn':
      return { ...state, isUserLoggedIn: action.userLoggedIn };
    case 'setLatestLesson':
      return { ...state, latestLesson: action.latestLesson };
    case 'setLessonStatus':
      let units = state.course.units;
      units = units.map((unit) => {
        if (unit.key === action.unitKey) {
          let lessons = unit.lessons.map((lesson) => {
            if (lesson.slug === action.lessonKey) {
              return { ...lesson, status: action.status };
            }
            return lesson;
          });
          return { ...unit, lessons };
        }
        return unit;
      });
      return { ...state, course: { ...state.course, units } };
    case 'updateVersion':
      return {
        ...state,
        cachingVersion: Math.floor(Math.random() * 1000),
      };
    case 'setStripeKey':
      return { ...state, stripeKey: action.key };
    case 'purchaseCourse':
      return {
        ...state,
        refreshTime: action.time,
        isStripeModalOpen: false,
      };
    case 'openStripeModal':
      return { ...state, isStripeModalOpen: true };
    case 'closeStripeModal':
      return { ...state, isStripeModalOpen: false };
    default:
      return state;
  }
};

const AppProvider = ({ children }) => {
  const [appState, appDispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ appState, appDispatch }}>
      {children}
    </AppContext.Provider>
  );
};

const AppConsumer = AppContext.Consumer;

export { AppContext, AppProvider, AppConsumer };
